import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";

import "./vendor/hugerte";
import { AutocompleteUsers } from "./mensajes/AutocompleteUsers";
import { AttachementOffcanvasList } from "./mensajes/AttachementList";
import { PlanillaCalificaciones } from "./calificaciones/PlanillaCalificaciones";
import { InscripcionForm } from "./inscripcion/InscripcionForm";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap'

// import "@fontsource/source-sans-pro"; // Defaults to weight 400
import "@fontsource/source-sans-pro/200.css"; // Specify weight
import "@fontsource/inter/200.css"; 
// import "@fontsource/source-sans-pro/400-italic.css"; // Specify weight and style


export * from '@popperjs/core'
import cx from "classnames";
const ToggleSidebarButton = () => {
  const ref = React.useRef();
  const [full, setFull] = React.useState(false);
  const [hidden, setHidden] = React.useState(true);
  const handleClick = () => setFull(!full);

  useEffect(() => {
    const row = ref.current.closest(".row");
    const sidebar = row.querySelector("nav");
    const mainContent = sidebar.closest(".row").querySelector("main");

    if (full) {
      sidebar.classList.add("d-none");
      mainContent.classList.remove("col-9");
      mainContent.classList.add("col-12");
    } else {
      sidebar.classList.remove("d-none");
      mainContent.classList.remove("col-12");
      mainContent.classList.add("col-9");
    }
  }, [full]);
  useEffect(() => {
    const row = ref.current.closest(".row");
    const mouseenter = () => setHidden(false);
    const mouseleave = () => setHidden(true);
    row.addEventListener("mouseenter", mouseenter);
    row.addEventListener("mouseleave", mouseleave);
    return () => {
      row.removeEventListener("mouseenter", mouseenter);
      row.removeEventListener("mouseleave", mouseleave);
    };
  }, []);

  return (
    <button
      hidden={hidden}
      className="btn btn-secondary px-1 position-absolute"
      onClick={handleClick}
      classList
      ref={ref}
      style={{ left: "-10px", top: "2px" }}
    >
      <i className={cx("fas", full ? "fa-chevron-right" : "fa-chevron-left")} />
    </button>
  );
};

const appMapping = [
  ["#id_recipients_autocomplete", AutocompleteUsers],
  ["#attachments-list", AttachementOffcanvasList],
  ["#planilla-calificaciones", PlanillaCalificaciones],
  ["#toggleSidebarRoot", ToggleSidebarButton],
  ["#inscripcion-root", InscripcionForm],
];

document.addEventListener("DOMContentLoaded", () => {
  appMapping.forEach(([selector, Component]) => {
    const domElement = document.querySelector(selector);
    const rootRef = React.createRef();
    if (domElement) {
      rootRef.current = domElement;  
      createRoot(domElement).render(<Component ref={rootRef} />);
    }
  });
});
